import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { Puff } from 'react-loader-spinner';
import { CSSProperties } from 'react';

interface SpinnerProps {
  position?: CSSProperties['position'];
  show?: boolean | null;
}

const Spinner: React.FC<SpinnerProps> = ({ position = 'fixed', show = null }) => {
  return (
    <>
      {show && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            zIndex: 999,
            marginTop: '10px',
          }}
        >
          <Puff color="#E21824" height={100} width={100} visible={true} />
          <Typography>Loading Data...</Typography>
        </Box>
      )}
    </>
  );
};

export default Spinner;
